import { render } from "./parseWysiwyg.vue?vue&type=template&id=66633574&scoped=true"
import script from "./parseWysiwyg.vue?vue&type=script&lang=js"
export * from "./parseWysiwyg.vue?vue&type=script&lang=js"

import "./parseWysiwyg.vue?vue&type=style&index=0&id=66633574&lang=less"
import "./parseWysiwyg.vue?vue&type=style&index=1&id=66633574&scoped=true&lang=less"

import exportComponent from "M:\\Meshkat\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66633574"]])

export default __exports__